/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FragmentNames {
  ADITIVO_CONTRATUAL_DETALHES = 'aditivo-contratual-detalhes',
  APPLICATION = 'application',
  ASSING_TERM = 'assing-term',
  CHAMADO_DETALHES = 'chamado-detalhes',
  CHAMADO_NOVO = 'chamado-novo',
  CHAMADOS = 'chamados',
  CONSENTIMENTOS = 'consentimentos',
  COOKIE_POLICIES = 'cookie-policies',
  DADOS_CONTRATO = 'dados-contrato',
  DADOS_PESSOAIS = 'dados-pessoais',
  DASHBOARD = 'dashboard',
  DETALHES_AUTORIZACAO = 'detalhes-autorizacao',
  DETALHES_REQUISICAO = 'detalhes-requisicao',
  DINAMICO = 'dinamico',
  HISTORICO_AUTORIZACOES = 'historico-autorizacoes',
  HISTORICO_CANCELAMENTOS = 'historico-cancelamentos',
  HISTORICO_PARTICIPACOES = 'historico-participacoes',
  HISTORICO_PROTOCOLOS = 'historico-protocolos',
  HISTORICO_REQUISICOES = 'historico-requisicoes',
  INACTIVITY = 'inactivity',
  INFORMACOES_ADICIONAIS = 'informacoes-adicionais',
  LOGIN = 'login',
  MENSAGEM_DETALHES = 'mensagem-detalhes',
  MENSAGENS = 'mensagens',
  MENSAGENS_RESUMO = 'mensagens-resumo',
  MENSALIDADES = 'mensalidades',
  MEUS_DADOS = 'meus-dados',
  MODAL_ACESSIBILIDADE = 'modal-acessibilidade',
  MODAL_CADASTRAR_NOVO_USUARIO = 'modal-cadastrar-novo-usuario',
  MODAL_CONFIRMAR_USUARIO = 'modal-confirmar-usuario',
  MODAL_EXTRATO_UTILIZACAO = 'modal-extrato-utilizacao',
  MODAL_ITEM_TISS = 'modal-item-tiss',
  MODAL_NOVA_SENHA = 'modal-nova-senha',
  MODAL_OBSERVACOES_DADOS_PESSOAIS = 'modal-observacoes-dados-pessoais',
  MODAL_OBSERVACOES_MENSALIDADES = 'modal-observacoes-mensalidades',
  MODAL_RECUPERAR_SENHA = 'modal-recuperar-senha',
  MODAL_REDEFINIR_SENHA = 'modal-redefinir-senha',
  MODAL_RELATORIO = 'modal-relatorio',
  PRIVACY = 'privacy',
  RECEBER_BOLETOS_EMAIL = 'receber-boletos-email',
  REDIRECT = 'redirect',
  RELATORIO_PDF = 'relatorio-pdf',
  ROOT = 'root',
  ROUTES = 'routes',
  SOLICITAR_CANCELAMENTO = 'solicitar-cancelamento',
  SOLICITAR_PARTICIPACAO = 'solicitar-participacao',
  SOLICITAR_VIA = 'solicitar-via',
  TIPO_CHAMADO = 'tipo-chamado',
  TISS = 'tiss',
}
export { FragmentNames };
